// @ts-nocheck
import { Button, Flex } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';
import { useWatch } from 'react-hook-form';

import { useZodFormContext } from '../../../hooks/useZodForm.js';
import { PairedSalesFormSchema } from '../types.js';

const PickPairFooter = ({
  onCancelButtonClick,
  onNextButtonClick,
}: {
  onCancelButtonClick: () => void;
  onNextButtonClick: () => void;
}) => {
  const { control } = useZodFormContext<PairedSalesFormSchema>();

  const nextButtonDisabled =
    useWatch({
      control,
      name: 'selectedPairs',
      defaultValue: [],
    }).length === 0;

  return (
    <>
      <Button size="md" variant="secondary" text={'Back'} onClick={onCancelButtonClick} />
      <Button size="md" text={'Next'} onClick={onNextButtonClick} disabled={nextButtonDisabled} />
    </>
  );
};

const AdjustPairsFooter = ({
  onBackButtonClick,
  onSubmitButtonClick,
}: {
  onBackButtonClick: () => void;
  onSubmitButtonClick: () => void;
}) => (
  <>
    <Button size="md" variant="secondary" text={'Back'} onClick={onBackButtonClick} />
    <Button size="md" text={'Save & Close'} onClick={onSubmitButtonClick} />
  </>
);

export function AdjustPairedSalesLayout({
  step,
  onCancelButtonClick,
  onNextButtonClick,
  onBackButtonClick,
  onSubmitButtonClick,
  children,
}: {
  step: number;
  onCancelButtonClick: () => void;
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
  onSubmitButtonClick: () => void;

  children?: ReactNode;
}) {
  return (
    <Flex width="100%" height="100%" flexDirection="column">
      <Flex gap="1rem" flexDirection="column" overflowY="auto" flexGrow={1}>
        {children}
      </Flex>
      <Flex
        display="flex"
        gap={2}
        borderTopWidth="1px"
        borderTopColor="surface4"
        borderStyle="solid"
        paddingX={6}
        paddingY={3}
      >
        {step === 0 ? (
          <PickPairFooter
            onCancelButtonClick={onCancelButtonClick}
            onNextButtonClick={onNextButtonClick}
          />
        ) : (
          <AdjustPairsFooter
            onBackButtonClick={onBackButtonClick}
            onSubmitButtonClick={onSubmitButtonClick}
          />
        )}
      </Flex>
    </Flex>
  );
}
